import gql from 'graphql-tag';

export default gql`
  query downloadAllReceipts {
    downloadAllReceipts {
      url
    }
  }
`;
